import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {isMobileOnly} from 'react-device-detect';
import EsOrderDoneBrList from './EsOrderDoneBrList'

const EsOrderDoneListBlock = styled.div``;

const EsOrderDoneListHeaderBlcok = styled.div`
    ${isMobileOnly?`
    font-size: 16px;
    font-weight: 500;
    `:`
    font-size: 18px;
    font-weight: 500;
    `};

    height: 60px;
    
    line-height: 60px;
    text-align: left;
    color: #111111;

    .num {
        ${isMobileOnly?`
        font-size: 18px;
        font-weight: 600;
        `:`
        font-size: 20px;
        font-weight: 600;
        `};
        
    }
`;

const EsOrderDoneListHeaderLineBlcok = styled.div`
    height: 2px;
    background-color: #111111;
    margin-bottom: 20px;
`;


const EsOrderDoneList = ({itemBrList, isEsInfo, orderinfo}) => {

    const { esOrderInfo } = useSelector(
        ({ esOrderReducer }) => ({
            esOrderInfo: esOrderReducer.esOrderInfo,
        })
    );


    if (esOrderInfo === null || esOrderInfo === undefined) {
        return <EsOrderDoneListBlock />
    }

    if (itemBrList === null || itemBrList === undefined || itemBrList.length === 0) {
        return <EsOrderDoneListBlock />
    }

    return (
        <EsOrderDoneListBlock className="clearfix">
            {/* <EsOrderDoneListHeaderBlcok>
                견적서 <span className="num">{itemBrList.length}</span>건
            </EsOrderDoneListHeaderBlcok>
            {!isMobileOnly&&<EsOrderDoneListHeaderLineBlcok />} */}
        {
            itemBrList.map((item, idx) => {
               return <EsOrderDoneBrList key={(item.es_rqst_id) * 1 + idx} item={item} isEsInfo={isEsInfo} orderinfo={orderinfo}/>
            })
        }
        </EsOrderDoneListBlock>
    );
};

export default EsOrderDoneList;